import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadOrderDetailsAction,
    ILoadOrderDetailsSuccessAction,
    LoadOrderDetailsErrorAction
} from '../actions/load-order-details';
import { IOrderTrackerState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadOrderDetailsAction
    = ILoadOrderDetailsAction
    | ILoadOrderDetailsSuccessAction
    | LoadOrderDetailsErrorAction;

const init = (state: IOrderTrackerState, action: LoadOrderDetailsAction) => ({
    ...state,
    orderDetails: {
        ...state.orderDetails,
        status: action.status
    }
});

const success = (state: IOrderTrackerState, action: LoadOrderDetailsAction) => {
    const filters = state.search.orders.filters;
    let orderProductDetails = (action as ILoadOrderDetailsSuccessAction).data.ProductDetails;

    if (filters && filters.location && filters.location.length) {
        const filteredLocations = filters.location.map((i) => i.value.toLowerCase()).sort();
        orderProductDetails = orderProductDetails.map((l) => {
            // tslint:disable-next-line:prefer-object-spread
            const o = Object.assign({}, { ...l });
            const itemLocation = ((l.siteSuburb && l.siteState) ? l.siteSuburb + ', ' + l.siteState
                : (l.siteSuburb) ? l.siteSuburb : l.siteState).toLowerCase();
            const index = filteredLocations.indexOf(itemLocation.toLowerCase());
            o.index = (index > -1) ? filteredLocations.length - index : index;
            return o;
        })
            .sort((a, b) => b.index - a.index)
            .map((l) => { delete l.index; return l; });
    }

    return ({
        ...state,
        orderDetails: {
            status: action.status,
            data: {
                OrderSummary: (action as ILoadOrderDetailsSuccessAction).data.OrderSummary,
                ProductDetails: orderProductDetails
            }
        }
    })
};

const failure = (state: IOrderTrackerState, action: LoadOrderDetailsAction) => ({
    ...state,
    orderDetails: {
        ...initialState.orderDetails,
        status: action.status,
        error: (action as LoadOrderDetailsErrorAction).error
    }
});

export const loadOrderDetailsReducer = createAsyncReducer(initialState, init, success, failure);
